module.exports = __webpack_public_path__ + "static/media/filter-new-orange.52397c40.svg";